var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delivery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delivery"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.141587409,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "group-16",
    transform: "translate(2.000000, 5.000000)",
    stroke: "#80959D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.305,11.681 L1.555,11.681 L1.555,1.334 L11.945,1.334 L11.945,11.723 L8.285,11.723 M4.389,4.639 L9.111,4.639 M7.223,6.528 L10.056,6.528 M11.945,7.473 L19.5,7.473 M12.889,7.473 L19.5,7.473",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.334,
    cy: 11.723,
    r: 1.889
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.723,
    cy: 11.723,
    r: 1.889
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "12.889 4.167 17.544 4.167 19.5 7.577 19.5 12.667 18.257 12.667"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.0fcaefab5d6b3c11a5c0b73b6b9f6f6c.svg";
export { ForwardRef as ReactComponent };